import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2'; // Import Bar instead of Pie
import { api } from '../../../api'; // Import api module correctly
import Cookies from 'js-cookie';

const CircleChartVendor = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const company_id = Cookies.get('company_id');
    api.get(`countstockitemscategorywiseSTM.php?company_id=${company_id}`)
      .then(response => {
        const result = response.data;
        if (result.status === 'success' && Array.isArray(result.vendor_products)) {
          const categoryData = result.vendor_products.map(item => ({
            label: item.product_name,
            value: parseInt(item.available_stock)
          }));

          // Find the indices of the 1st and 2nd highest values
          const values = categoryData.map(item => item.value);
          let first = -1, second = -1;
          let firstIdx = -1, secondIdx = -1;
          values.forEach((val, idx) => {
            if (val > first) {
              second = first;
              secondIdx = firstIdx;
              first = val;
              firstIdx = idx;
            } else if (val > second) {
              second = val;
              secondIdx = idx;
            }
          });

          // Assign colors: #FFCC99 for 1st and 2nd highest, #E5E5E5 for others
          const highlightColor = '#FFCC99';
          const otherColor = '#E5E5E5';
          const backgroundColor = values.map((_, idx) =>
            idx === firstIdx || idx === secondIdx ? highlightColor : otherColor
          );

          setData({
            labels: categoryData.map(item => item.label),
            datasets: [{
              label: 'Item Counts', // Label for the dataset
              data: categoryData.map(item => item.value),
              backgroundColor,
            }],
          });
        } else {
          console.error('Error fetching data:', result.message || 'vendor_products is not an array');
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);

  return (
    <div>
      {data ? (
        <Bar
          data={data}
          options={{
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  min: 0, // Set a minimum value for the y-axis scale
                }
              }]
            }
          }}
        />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default CircleChartVendor;



